var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTarget48Line = function SvgIconTarget48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.9c-1.71 0-3.1 1.39-3.1 3.1 0 1.71 1.39 3.1 3.1 3.1 1.71 0 3.1-1.39 3.1-3.1 0-1.71-1.39-3.1-3.1-3.1Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22.3h-1.92c-.77-5.92-5.46-10.61-11.38-11.38V9h-3.4v1.92c-5.92.77-10.61 5.46-11.38 11.38H9v3.4h1.92c.77 5.92 5.46 10.61 11.38 11.38V39h3.4v-1.92c5.92-.77 10.61-5.46 11.38-11.38H39v-3.4ZM25.7 33.64V31.5h-3.4v2.14a9.808 9.808 0 0 1-7.94-7.94h2.14v-3.4h-2.14c.71-4.04 3.9-7.23 7.94-7.94v2.14h3.4v-2.14c4.04.71 7.23 3.9 7.94 7.94H31.5v3.4h2.14a9.808 9.808 0 0 1-7.94 7.94Z",
    fill: "current"
  })));
};
export default SvgIconTarget48Line;